.se-container-wide {
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
  padding-left: 15px;
  padding-right: 15px;
}

@media screen and (min-width: 980px) {
  .se-container-wide {
    padding-left: 10px;
    padding-right: 10px;
  }
}

:host {
  display: block;
  display: block;
  margin: 0 auto;
  padding: 0 16px 20px;
  box-sizing: border-box;
  max-width: 1200px;
  overflow: visible;
  color: #626469;
  margin-top: 24px;
  padding-bottom: 0;
}

:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}

@media screen and (min-width: 980px) {
  :host {
    padding: 0 10px;
  }
}

.range-list__title {
  color: #333333;
  font-size: 1.875rem;
  margin-top: 0;
  font-weight: normal;
  margin-bottom: 24px;
}

@media screen and (min-width: 980px) {
  .range-list__title {
    font-size: 2.25rem;
  }
}

.range-list {
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex-wrap: wrap;
}

@media screen and (max-width: 719px) {
  .range-list {
    align-items: center;
    flex-direction: column;
  }
}

@media screen and (min-width: 980px) {
  .range-list {
    flex-direction: row;
    flex-wrap: wrap;
  }

  :host(:not([dir="rtl"])) .range-list > :nth-child(4n) {
    margin-right: 0;
  }

  :host([dir="rtl"]) .range-list > :nth-child(4n) {
    margin-left: 0;
  }
}

.range-list__item {
  width: 280px;
  margin-bottom: 14px;
  display: flex;
}

:host(:not([dir="rtl"])) .range-list__item {
  margin-right: 20px;
}

:host([dir="rtl"]) .range-list__item {
  margin-left: 20px;
}

@media screen and (min-width: 980px) {
  .range-list__item {
    max-width: calc(25% - 15px);
    margin-bottom: 20px;
  }
}

@media screen and (max-width: 719px) {
  :host(:not([dir="rtl"])) .range-list__item {
    margin-right: 0;
  }

  :host([dir="rtl"]) .range-list__item {
    margin-left: 0;
  }
}

.range-card {
  width: 100%;
  background-color: #ffffff;
  overflow: hidden;
}